/* 甘寧傳・第 2 章：夷陵・談笑自若（建安十三年冬，208）
 * 史實：〈甘寧傳〉正文：「攻曹仁於南郡，未拔，寧建計先徑進取夷陵，往即得其城，因入守之。時手下有數百兵，并所新得，僅滿千人。
 *       曹仁乃令五六千人圍寧。寧受攻累日，敵設高樓，雨射城中，士衆皆懼，惟寧談笑自若。遣使報瑜，瑜用呂蒙計，帥諸將解圍。」
 *       〈呂蒙傳〉正文：蒙曰「留凌公績，蒙與君行，解圍釋急……」，「又說瑜分遣三百人柴斷險道，賊走可得其馬」；
 *       「軍到夷陵，即日交戰，所殺過半。敵夜遁去，行遇柴道，騎皆捨馬步走。兵追蹙擊，獲馬三百匹」。
 * 流程：1. 進城，打散守城的曹兵（往即得其城）。
 *       2. 城門一關，曹仁的兵圍城：四座高樓往城裡放箭（紅圈），曹兵不時從城牆架梯登城。
 *          城中的「軍心」被箭射、被登城、守兵陣亡就往下掉；甘寧站在守兵身邊不動（附近沒有敵人）就「談笑自若」把軍心拉回來。軍心歸零就失守。
 *       3. 周瑜、呂蒙解圍：曹騎往西逃，撞上呂蒙預先「柴斷」的險道，只能捨馬步走。開西門追擊，斬得越多，獲馬越多。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, rout, TROOPS } from '../kit.ts';
import { tower } from './ganning_kit.ts';
import { CITY, GATES, TOWERS, POSTS, CLIMB } from '../maps/ganning_yiling.ts';

const LV = 10, HOLD = 90, CHASE = 30, CHAI = [1500, 2200];
const WEI = { spec: TROOPS.wei, name: '曹兵', hp: 420, maxHp: 420, atk: 24, ms: 245 };
const inCity = (u) => Math.abs(u.x - CITY.x) < CITY.hw - 20 && Math.abs(u.y - CITY.y) < CITY.hh - 20;
const QUIPS = ['敵人的箭，正好拿來燒火煮飯。', '曹仁只會躲在樓上放箭，諸君笑他一笑！', '周公瑾的援兵轉眼就到，怕什麼？', '想當年在巴郡，甘某聽的箭聲比這多。'];

export default {
  id: 'ganning-2', map: 'ganning_yiling', hero: 'ganning',
  title: '第 2 章　夷陵・談笑自若', year: '建安十三年冬（208）',
  brief: {
    quote: [{ text: '寧受攻累日，敵設高樓，雨射城中，士衆皆懼，惟寧談笑自若。', src: '《三國志·吳書·甘寧傳》' }],
    text: '赤壁之後，周瑜進攻南郡的曹仁，久攻不下。甘寧建議先取上游的夷陵，帶著幾百人一到就拿下了城。曹仁立刻派五六千人回頭圍城。',
    goals: ['取夷陵城', '守城：撐到周瑜、呂蒙解圍（軍心不能歸零）', '追擊：獲馬'],
  },
  words: { ally: '守兵', foe: '曹兵' },
  stars: [
    { text: '如史：談笑自若——談笑 5 次以上', ok: (m) => m.vars.talks >= 5 },
    { text: '軍心始終保持在 30 以上', ok: (m) => m.vars.moraleMin >= 30 },
    { text: '柴道追擊：獲馬 6 匹以上', ok: (m) => m.vars.horses >= 6 },
  ],
  steps: [
    { // 1. 往即得其城
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        V.men = Array.from({ length: 6 }, (_, i) => { const u = m.recruit(me.x - 90 - (i % 3) * 50, me.y - 70 + Math.floor(i / 3) * 140, '吳兵'); m.join(u, me); return u; });
        V.garrison = Array.from({ length: 6 }, (_, i) => m.foe('huangjin', CITY.x + 300 - (i % 3) * 200, CITY.y - 150 + Math.floor(i / 3) * 300, Object.assign({}, WEI, { name: '守城兵' })));
        m.line('甘寧', '曹仁全力守江陵，夷陵空虛。先取夷陵！');
        m.mark('city', CITY.x, CITY.y, '夷陵');
        m.obj('take', '取夷陵城', V.garrison.length);
      },
      tick(m) { const V = m.vars, n = V.garrison.filter((u) => !u.alive).length; m.prog('take', n); return n >= V.garrison.length && inCity(m.w.player); },
    },
    { // 2. 受攻累日
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.done('take'); m.unmark('city');
        m.card('往即得其城，因入守之。時手下有數百兵，并所新得，僅滿千人。', '《甘寧傳》');
        for (const k of ['n', 's', 'w', 'e']) m.gate(k, GATES[k][0], GATES[k][1], 170, 'citygate');
        // 守兵：跟來的吳兵，加上新收的降兵，分守城牆各處
        for (const u of m.alive(V.men)) u.owner = null;
        V.guard = POSTS.map(([x, y], i) => { const u = m.recruit(x, y, i % 2 ? '降兵' : '吳兵'); u.hp = u.maxHp = 520; return u; }).concat(m.alive(V.men));
        V.guard.forEach((u, i) => { const p = POSTS[i % POSTS.length]; u.home = [p[0] + (i >= POSTS.length ? 60 : 0), p[1]]; });
        V.towers = TOWERS.map(([x, y]) => m.folk(x, y, { name: '高樓', still: true, near: 1, draw: tower }));
        V.morale = 100; V.moraleMin = 100; V.talks = 0; V.t0 = w.t; V.volT = 3; V.climbT = 6; V.climbers = []; V.dead = 0;
        m.after(1.5, () => { m.big('曹仁的兵圍城了！'); m.card('曹仁乃令五六千人圍寧。寧受攻累日，敵設高樓，雨射城中，士衆皆懼。', '《甘寧傳》'); });
        m.after(5, () => m.line('甘寧', '慌什麼！來，坐下喝一碗。'));
        m.after(8, () => m.line('提示', '城裡的「軍心」被箭射、被登城、守兵陣亡就往下掉。站在守兵身邊不動（附近沒有敵人），甘寧就會談笑自若（箭落在身上也不中斷），把軍心拉回來。'));
        m.obj('hold', '');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars, t = w.t - V.t0;
        // 高樓放箭：大多射守兵，也會射甘寧
        V.volT -= dt;
        if (V.volT <= 0) {
          V.volT = Math.max(1.5, 2.3 - t / 120);
          const tw = V.towers[Math.floor(SG.rand() * V.towers.length)], gs = m.alive(V.guard);
          const tg = SG.rand() < 0.35 && inCity(me) ? me : gs[Math.floor(SG.rand() * gs.length)];
          if (tg) {
            tw.fired = w.t; // 畫面：樓上一閃
            const x = tg.x + (SG.rand() - 0.5) * 80, y = tg.y + (SG.rand() - 0.5) * 60;
            m.warn({ x, y, r: 115, t: 1.2, col: '#ff5040', fn: (hit) => {
              let n = 0;
              for (const u of hit) if (u.team === 0) { m.hurt(u, u === me ? 60 : 35, 1, { stagger: 0.2 }); if (u !== me) n++; }
              if (n) V.morale -= 1.2;
              w.fx({ k: 'boom', x, y, r: 115, col: '#c86a3a' });
            } });
          }
        }
        // 登城：一隊曹兵從城牆內側冒出來
        V.climbT -= dt;
        if (V.climbT <= 0 && t < HOLD - 8) {
          V.climbT = 16; V.wave = (V.wave || 0) + 1;
          const [x, y] = CLIMB[Math.floor(SG.rand() * CLIMB.length)];
          for (let i = 0; i < 3 + Math.min(2, Math.floor(V.wave / 3)); i++) { const u = m.foe('huangjin', x + (i - 1.5) * 60, y, Object.assign({}, WEI, { hp: 300, maxHp: 300 })); V.climbers.push(u); }
          m.line('守兵', '曹兵爬上城了！'); m.mark('climb', x, y, '登城', true);
        }
        const up = m.alive(V.climbers);
        if (!up.length) m.unmark('climb');
        V.morale -= up.length * 0.4 * dt;
        // 守兵陣亡
        const dead = V.guard.filter((u) => !u.alive).length;
        if (dead > V.dead) { V.morale -= 5 * (dead - V.dead); V.dead = dead; }
        // 談笑自若
        const near = m.alive(V.guard).filter((u) => SG.gd(u.x, u.y, me.x, me.y) < 320).length;
        const foeNear = w.units.some((u) => u.team === 1 && u.alive && !u.untargetable && SG.gd(u.x, u.y, me.x, me.y) < 500);
        if (!me.chan && inCity(me) && near >= 2 && !foeNear && m.idle(me)) m.chan(me, 2, '談笑自若', () => {
          V.morale = Math.min(100, V.morale + 14); V.talks++;
          m.line('甘寧', QUIPS[V.talks % QUIPS.length]);
          w.fx({ k: 'spark', x: me.x, y: me.y - 60, col: '#ffe28a' });
        }, { hurt: false }); // 箭落在身邊也照樣談笑
        V.morale = Math.min(100, V.morale); V.moraleMin = Math.min(V.moraleMin, V.morale);
        if (V.morale <= 0) { m.lose('士衆皆懼，夷陵失守'); return false; }
        m.get('hold').text = `守住夷陵（${Math.max(0, Math.ceil(HOLD - t))} 秒）　軍心 ${Math.round(V.morale)}`;
        return t >= HOLD;
      },
    },
    { // 3. 解圍：柴道追擊
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.done('hold'); m.unmark('climb');
        m.card('遣使報瑜，瑜用呂蒙計，帥諸將解圍。', '《甘寧傳》');
        m.after(3, () => m.card('留凌公績，蒙與君行，解圍釋急，勢亦不久，蒙保公績能十日守也。', '《呂蒙傳》'));
        V.zy = ally(w, 'zhouyu', GATES.e[0] + 400, GATES.e[1], LV);
        V.lm = ally(w, 'lvmeng', GATES.e[0] + 400, GATES.e[1] + 120, LV);
        rout(m, w, m.alive(V.climbers), [CITY.x, 400]);
        m.ungate('w'); m.ungate('e');
        // 呂蒙預先柴斷的險道
        m.gate('chai', CHAI[0], CHAI[1], 200, 'abatis');
        V.horse = [];
        for (let i = 0; i < 10; i++) {
          const u = m.foe('huangjin', GATES.w[0] - 250 - (i % 5) * 70, GATES.w[1] - 200 + Math.floor(i / 5) * 400, Object.assign({}, WEI, { name: '曹騎', spec: TROOPS.wei, ms: 290 }));
          u.flee = true; u.home = [CHAI[0] + 230, CHAI[1] + ((i % 3) - 1) * 120]; V.horse.push(u);
        }
        V.t1 = w.t; V.horses = 0;
        m.big('周瑜、呂蒙來了！');
        m.after(2, () => m.line('呂蒙', '我已分三百人用柴木塞斷西邊的險道，賊騎跑不掉！'));
        m.mark('chai', CHAI[0], CHAI[1], '柴道');
        m.obj('chase', `追擊：獲馬（${CHASE} 秒）`);
      },
      tick(m, w) {
        const V = m.vars, t = w.t - V.t1;
        for (const u of V.horse) {
          if (!u.alive) { if (!u.got) { u.got = true; V.horses++; } continue; }
          if (u.flee) { u.target = null; u.think = 0.4; if (u.x < CHAI[0] + 400) { u.flee = false; u.name = '曹兵'; u.ms = 200; u.home = [u.x, u.y]; } } // 騎皆捨馬步走
        }
        if (!V.said && V.horse.some((u) => !u.flee)) { V.said = true; m.card('敵夜遁去，行遇柴道，騎皆捨馬步走。', '《呂蒙傳》'); }
        m.get('chase').text = `追擊：獲馬 ${V.horses}（${Math.max(0, Math.ceil(CHASE - t))} 秒）`;
        return t >= CHASE || V.horses >= V.horse.length;
      },
    },
    { // 4. 所殺過半
      enter(m, w) {
        const V = m.vars;
        m.done('chase'); m.unmark('chai');
        rout(m, w, V.horse, [300, 2200]);
        m.card(`兵追蹙擊，獲馬三百匹，方船載還。`, '《呂蒙傳》');
        m.after(3, () => m.line('周瑜', `興霸以千人當五六千，${V.talks >= 5 ? '談笑自若，' : ''}真壯士也！`));
        m.after(6, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) {
    const V = m.vars;
    if (!w.player.alive) { m.lose('甘寧陣亡'); return; }
    if (V.zy) { allyTick(w, V.zy, w.player); allyTick(w, V.lm, w.player); }
  },
};
